module.exports = __webpack_public_path__ + "img/login-trantor.2e5d1f46.png";